import React, { useState, useEffect, useCallback, useContext, useMemo } from "react";
import logo from "../images/logo.png";
import NavLink from "./NavLink";
import { List } from "react-movable";
import {
  Add as VouchersIcon,
  Redeem as InventoryIcon,
  AccountBalanceWalletOutlined as AccountIcon,
  AutoAwesomeMosaicOutlined as MasterIcon,
  AssessmentOutlined as ReportsIcon,
  FlashOn as QuickAccessIcon,
  SettingsOutlined as SettingsIcon,
} from "@mui/icons-material";
import { openDB } from "idb";
import { v4 as uuidv4 } from "uuid";
import DraggableList from "./DraggableList";
import ReportsCurrentStock from "./inventory-account/ReportsCurrentStock";
import ReportsAllVouchers from "./inventory-account/ReportsAllVouchers";
import VoucherAccounting from "./inventory-account/VoucherAccounting";
import VoucherInventory from "./inventory-account/VoucherInventory";
import VoucherInventoryWaste from "./inventory-account/VoucherInventoryWaste";
import VoucherPurchaseInvoice from "./inventory-account/VoucherPurchaseInvoice";
import VoucherSaleInvoice from "./inventory-account/VoucherSaleInvoice";
import VoucherStockTransfer from "./inventory-account/VoucherStockTransfer";
import InventoryItem from "./inventory-account/InventoryItem";
import InventoryWarehouse from "./inventory-account/InventoryWarehouse";
import AccountLedger from "./inventory-account/AccountLedger";
import AccountLedgerGroup from "./inventory-account/AccountLedgerGroup";
import Context from '../context/context'
import UfFb from "../firebase/unsynced_files_firebase";
import { useLocation } from "react-router-dom";

let titleData = [
  { value: "report-orders", name: "Orders Report" },
  { value: "page5", name: "Menu and Seats" },
  { value: "page1", name: "Running Orders" },
  { value: "page2", name: "Order Details" },
  { value: "upload", name: "Upload" },
  { value: "Inv-Ac", name: "Vouchers" },
  { value: "Users", name: "User" },
  { value: "report-Customers", name: "Customers" },
  { value: "report-items", name: "Items Sales" },
  { value: "report-Order-tex", name: "Sales GST" },
  { value: "profit_lose_estimate", name: "Profit & Loss Estimate" },
  { value: "upi_payments", name: "UPI Payments" },
  { value: "setup", name: "Setup" },
];

const LeftPanel = ({
  isCatogories,
  setIsItemAvilableOpen,
  isItemAvilableOpen,
  newSectionCreated,
  setNewSectionCreated,
  setSectionDragged,
  setIsDailyReportSummary,
  isDailyReportSummary, isMealSchedulingOpen,
  setIsMealSchedulingOpen,
  setIsSeatModified,
  selectedValue,
  setSelectedValue,
  setIsSectionOpen
}) => {

  const [outlet, setOutlet] = useState([]);
  const [customerLinks, setCustomerLinks] = useState([]);
  const location=useLocation()
  const context = useContext(Context);
  const {
    selectedMenu,
    unSyncCount,
    updateUnSync,
    setForceRenderOrdersPage,
    setForceRenderPage1,
    generateMenues,
    setUnSyncCount,
    showWarning
  } = context;

  const categoriesList = useCallback(() => {
    return selectedMenu?.category_and_items?.filter(category => {
      category.menu_items = category.menu_items
        .filter(menu_item =>
          +menu_item.menu_item_status === 1 &&
          +menu_item.item_availability === 1 &&
          +menu_item.item_status === 1
        )
      if (category.menu_items.length > 0) return category
      else return null
    })?.map(c => c.category_name)
  }, [selectedMenu])

  useEffect(() => {
    const getDataFromIndexdDb = async () => {
      const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      const indSections = await db.transaction("outlet", "readonly").objectStore("outlet");
      const currentSections = (await indSections.getAll())[0];
      setCustomerLinks(currentSections?.customer_link_services?.find(a => a.service_name === "Schedule"))
      setOutlet(
        currentSections.section_details.sort((a, b) =>
          a.section_sort_order > b.section_sort_order ? 0 : -1
        )
      );
    };
    getDataFromIndexdDb();
  }, [newSectionCreated]);

  // Editing existing section in outlet.section_details collection in IndexedDB
  const handleSubmit = async (mealsData) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const outletStore = db
      .transaction("outlet", "readwrite")
      .objectStore("outlet");
    const value = (await outletStore.getAll())[0];
    const updatedValue = {
      ...value,
      section_details: mealsData,
    };
    await outletStore.put(updatedValue);
    mealsData.forEach(meal => {
      handleEditSectionUnsynced(meal);
    });
    setNewSectionCreated(uuidv4());
  };

  const mealsArrayChange = (meals, oldIndex, newIndex) => {
    let tempObjOld = meals[oldIndex - 1];
    let tempObjNew = meals[oldIndex - 1];
    // console.log(meals, oldIndex, newIndex);
    let mealsData = [];

    if (newIndex < oldIndex) {
      for (let index = 0; index < newIndex - 1; index++) {
        mealsData[index] = meals[index];
      }

      mealsData[newIndex - 1] = {
        ...tempObjOld,
        section_sort_order: `${newIndex}`,
      };

      for (let i = newIndex; i < oldIndex; i++) {
        mealsData[i] = {
          ...meals[i - 1],
          section_sort_order: `${parseInt(meals[i - 1].section_sort_order) + 1
            }`,
        };
      }

      for (let index = oldIndex; index <= meals.length - 1; index++) {
        mealsData.push(meals[index]);
      }
    } else if (newIndex > oldIndex) {
      //
      for (let index = 0; index < oldIndex - 1; index++) {
        mealsData.push(meals[index]);
      }

      for (let index = oldIndex; index < newIndex; index++) {
        mealsData[index - 1] = {
          ...meals[index],
          section_sort_order: `${parseInt(meals[index].section_sort_order) - 1
            }`,
        };
      }

      mealsData[newIndex - 1] = {
        ...tempObjNew,
        section_sort_order: `${newIndex}`,
      };

      for (let index = newIndex; index < meals.length; index++) {
        mealsData.push(meals[index]);
      }
    }
    console.log("mealsData", mealsData);
    setOutlet(mealsData);
    handleSubmit(mealsData);
    setSectionDragged(uuidv4());
  };

  // Editing existing section in unsynced_files collection in IndexedDB
  const handleEditSectionUnsynced = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("unsynced_files", "readwrite")
      .objectStore("unsynced_files");
    const ndata = {
      ...data,
      RECON_TIME: Date.now(),
      IDENTIFIER: "section-edit:" + data.section_uuid,
    };
    await tx.put(ndata);
    handleReconciliation(ndata);
    updateUnSync()
  };

  // Editing section in reconciliation collection in IndexedDB
  const handleReconciliation = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("reconciliation", "readwrite")
      .objectStore("reconciliation");
    const allReconRecords = await tx.getAll();
    const sectionsJsonExists = allReconRecords.find(
      (curr) => curr.IDENTIFIER === "section"
    );
    if (sectionsJsonExists) {
      const sections = sectionsJsonExists?.details?.filter(
        (section) => section.section_uuid !== data.section_uuid
      );
      const editData = {
        ...sectionsJsonExists,
        details: [
          ...sections,
          {
            section_uuid: data.section_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.put(editData);
    } else {
      const newdata = {
        IDENTIFIER: "section",
        details: [
          {
            section_uuid: data.section_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.add(newdata);
    }
  };

  const triggerSync = () => {
    if (!window.navigator.onLine) return showWarning({
      message: 'Internet Unavailable, cannot sync data with server !!',
      classname: 'active-red',
      time: 4000
    })

    UfFb.setSyncIntervals(
      localStorage.getItem("outlet_uuid"),
      setForceRenderOrdersPage,
      setForceRenderPage1,
      generateMenues,
      setUnSyncCount,
      true
    )
  }

  document.title = useMemo(() => {
    let title = titleData?.find((a) => location.pathname.includes(a.value));
    return title?.name || "FoodDo";
  }, [location]);
  
  // console.log("outletDats", customerLinks)
  return (
    <div className="left-panel" style={{ position: "relative" }}>
      <img src={logo} alt="" />
      <div className="nav" >
        {window.location.pathname.includes("/Inv-Ac") ? (
          <>
            <NavLink
              title={"Vouchers"}
              icon={<VouchersIcon sx={{ fontSize: 50 }} />}
              isActive={true}
              menuList={[
                {
                  name: "Inventory Voucher",
                  link: "/Inv-Ac",
                  content: <VoucherInventory />,
                },
                // {
                //   name: "Processing Voucher",
                //   link: "/Inv-Ac",
                //   content: <div className='underconstruction'>Coming Soon...</div>,
                // },
                {
                  name: "Stock Transfer Voucher",
                  link: "/Inv-Ac/Voucher-Stock-Transfer",
                  content: <VoucherStockTransfer />,
                },
                {
                  name: "Inventory Waste Voucher",
                  link: "/Inv-Ac",
                  content: <VoucherInventoryWaste />,
                },
                {
                  name: "Accounting Voucher",
                  link: "/Inv-Ac",
                  content: <VoucherAccounting />,
                },
                {
                  name: "Sale Invoice",
                  link: "/Inv-Ac",
                  content: <VoucherSaleInvoice />,
                },
                {
                  name: "Purchase Invoice",
                  link: "/Inv-Ac",
                  content: <VoucherPurchaseInvoice />,
                },
              ]}
            />
            <NavLink
              title={"Inventory"}
              icon={<InventoryIcon sx={{ fontSize: 50 }} />}
              isActive={true}
              menuList={[
                {
                  name: "Item",
                  link: "/Inv-Ac",
                  content: <InventoryItem />,
                },
                {
                  name: "Warehouse",
                  link: "/Inv-Ac",
                  content: <InventoryWarehouse />,
                },
              ]}
            />
            <NavLink
              title={"Account"}
              icon={<AccountIcon sx={{ fontSize: 50 }} />}
              isActive={true}
              menuList={[
                {
                  name: "Ledger",
                  link: "/Inv-Ac",
                  content: <AccountLedger />,
                },
                {
                  name: "Group",
                  link: "/Inv-Ac",
                  content: <AccountLedgerGroup />,
                },
              ]}
            />
            <NavLink
              title={"Reports"}
              icon={<ReportsIcon sx={{ fontSize: 50 }} />}
              isActive={true}
              menuList={[
                {
                  name: "All Voucher",
                  link: "/Inv-Ac",
                  content: <ReportsAllVouchers />,
                },
                {
                  name: "Current Stock",
                  link: "/Inv-Ac",
                  content: <ReportsCurrentStock />,
                },
              ]}
            />
          </>
        ) : (
          <>
            {!isCatogories ? (
              <>
                <NavLink
                  title={"Master"}
                  icon={<MasterIcon sx={{ fontSize: 50 }} />}

                  isActive={true}
                  menuList={[
                    {
                      name: "Menu and Seats",
                      link: "/page5",
                    },
                    {
                      name: "User",
                      link: "/Users",
                    },

                  ]}
                />
                <NavLink
                  title={"Reports"}
                  icon={<ReportsIcon sx={{ fontSize: 50 }} />}
                  isActive={false}
                  setIsDailyReportSummary={setIsDailyReportSummary}
                  isDailyReportSummary={isDailyReportSummary}

                  menuList={[
                    {
                      name: "Daily Summary",
                      link: "#",
                    },
                    {
                      name: "Orders",
                      link: "/report-orders",
                    },
                    {
                      name: "Customers",
                      link: "/report-Customers",
                    },
                    {
                      name: "Items Sales",
                      link: "/report-items",
                    },
                    {
                      name: "Sales GST",
                      link: "/report-Order-tex",
                    },
                    {
                      name: "Profit & Loss Estimate",
                      link: "/profit_lose_estimate",
                    },
                    {
                      name: "UPI Payments",
                      link: "/upi_payments",
                    },
                  ]}
                />
                <NavLink
                  setIsItemAvilableOpen={setIsItemAvilableOpen}
                  isItemAvilableOpen={isItemAvilableOpen}
                  isMealSchedulingOpen={isMealSchedulingOpen}
                  setIsMealSchedulingOpen={setIsMealSchedulingOpen}

                  title={"Quick Access"}
                  icon={<QuickAccessIcon sx={{ fontSize: 50 }} />}
                  isActive={false}
                  menuList={customerLinks.service_status === "Y" ? [
                    {
                      name: "Item Availability",
                      link: "#",
                    },
                    {
                      name: "Meal Calendar",
                      link: "#"
                    }
                  ] : [
                    {
                      name: "Item Availability",
                      link: "#",
                    },
                  ]}
                />
                <NavLink
                  title="Setup"
                  icon={<SettingsIcon sx={{ fontSize: 50 }} />}
                  href="/setup"
                  isActive={false}
                  menuList={[]}
                />
              </>
            ) : (
              <div>
                {outlet && !window.location.pathname.includes("/page2") && (
                  <List
                    values={outlet}
                    onChange={({ oldIndex, newIndex }) => {
                      // arrayMove(outlet, oldIndex, newIndex);
                      mealsArrayChange(outlet, oldIndex + 1, newIndex + 1);
                    }}
                    renderList={({ children, props }) => (
                      <ul {...props} className="draggableComponent">
                        {children}
                      </ul>
                    )}
                    renderItem={({ value, props }) => (
                      <li {...props} className="draggableList">
                        <DraggableList
                          {...props}
                          key={props.key}
                          draggable={true}
                          title={value.section_name}
                          isActive={true}
                          setIsSeatModified={setIsSeatModified}
                          item={value}
                          selectedValue={selectedValue}
                          setSelectedValue={setSelectedValue}
                          setIsSectionOpen={setIsSectionOpen}
                        />
                      </li>
                    )}
                  // lockVertically={true}
                  />
                )}
                {selectedMenu?.menu_uuid && window.location.pathname.includes("page2") ? (
                  <>
                    <NavLink key={Math.random()} title={"All"} />
                    {categoriesList()?.map((category) =>
                      <NavLink
                        key={Math.random()}
                        title={category}
                      />
                    )}
                  </>
                ) : ("")}
              </div>
            )}
          </>
        )}

      </div>
      {unSyncCount ?
        <div className="nav_link_container unsync-count-container" title='Sync Files Now' onClick={triggerSync}>
          <div>{unSyncCount}</div>
          <p>Unsynced</p>
        </div> : ''}
    </div>
  );
};

export default LeftPanel;
